document.addEventListener('DOMContentLoaded', () => {
  // === MOBILE MENU DRAWER HANDLING ===
  const menuDetails = document.querySelector('#Details-menu-drawer-container');
  const menuDrawer = document.querySelector('#menu-drawer');

  if (menuDetails && menuDrawer) {
    const observer = new MutationObserver(() => {
      if (menuDetails.hasAttribute('open')) {
        menuDrawer.removeAttribute('hidden');
        document.body.classList.add('menu-open');
      } else {
        menuDrawer.setAttribute('hidden', '');
        document.body.classList.remove('menu-open');
      }
    });

    observer.observe(menuDetails, { attributes: true, attributeFilter: ['open'] });
  }

  // === TABS FUNCTIONALITY ===
  const tabButtons = document.querySelectorAll('.kez-tab-btn');
  const tabContents = document.querySelectorAll('.kez-tab-content');

  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      const target = button.getAttribute('data-target');

      // Remove active classes
      tabButtons.forEach(btn => btn.classList.remove('active'));
      tabContents.forEach(tab => tab.classList.remove('active'));

      // Add active to current
      button.classList.add('active');
      document.getElementById(target).classList.add('active');
    });
  });
});






